import { AmountScreen } from './AmountScreen/AmountScreen';
import {
  CompanyScreen,
  REQUIRED_COMPANY_FIELDS,
} from './CompanyScreen/CompanyScreen';
import { DateOfBirthScreen } from './DateOfBirthScreen/DateOfBirthScreen';
import { DurationScreen } from './DurationScreen/DurationScreen';
import { EmailScreen } from './EmailScreen/EmailScreen';
import { FoundingDateScreen } from './FoundingDateScreen/FoundingDateScreen';
import { HomeAddressScreen } from './HomeAddressScreen/HomeAddressScreen';
import { NameScreen } from './NameScreen/NameScreen';
import { PhoneScreen } from './PhoneScreen/PhoneScreen';
import { PrivacyConsentScreen } from './PrivacyConsentScreen/PrivacyConsentScreen';
import { PurposeDetailsScreen } from './PurposeDetailsScreen/PurposeDetailsScreen';
import { PurposeScreen } from './PurposeScreen/PurposeScreen';
import { TurnoverScreen } from './TurnoverScreen/TurnoverScreen';
import { TScreenDef } from './types';
import { WebsiteScreen } from './WebsiteScreen/WebsiteScreen';
import { TMobileSignupForm } from '../form/form';

const allPresent =
  (...keys: (keyof TMobileSignupForm)[]) =>
  (form: TMobileSignupForm): boolean =>
    keys.every((key) => !!form[key]);

// Order is the single source of truth for the flow sequence; the nav hook
// reads it. `consent` is the terminal screen — once its personal stage
// persists, the flow hands off to the legacy /angebote route.
export const SCREEN_REGISTRY: TScreenDef[] = [
  {
    id: 'amount',
    stage: 'Get started',
    Content: AmountScreen,
    isAnswered: (form) => !!form.amount,
  },
  {
    id: 'duration',
    stage: 'Get started',
    Content: DurationScreen,
    isAnswered: (form) => !!form.loanDuration,
  },
  {
    id: 'purpose',
    stage: 'Get started',
    Content: PurposeScreen,
    isAnswered: (form) => !!form.loanPurpose,
  },
  {
    id: 'purpose-details',
    stage: 'Get started',
    Content: PurposeDetailsScreen,
    isAnswered: (form) =>
      !!form.loanPurpose &&
      (form.loanPurpose !== 'other' || !!form.loanPurposeDetails?.trim()),
  },
  {
    id: 'email',
    stage: 'Get started',
    Content: EmailScreen,
    isAnswered: (form) => !!form.email,
  },
  {
    id: 'company',
    stage: 'Business details',
    Content: CompanyScreen,
    isAnswered: allPresent(...REQUIRED_COMPANY_FIELDS),
  },
  {
    id: 'founding-date',
    stage: 'Business details',
    Content: FoundingDateScreen,
    isAnswered: allPresent('startDateMonth', 'startDateYear'),
  },
  {
    id: 'website',
    stage: 'Business details',
    Content: WebsiteScreen,
    isAnswered: () => true, // Optional field
  },
  {
    id: 'turnover',
    stage: 'Business details',
    Content: TurnoverScreen,
    isAnswered: allPresent('last12MonthsTurnover'),
  },
  {
    id: 'name',
    stage: 'Personal details',
    Content: NameScreen,
    isAnswered: allPresent('title', 'firstName', 'lastName'),
  },
  {
    id: 'date-of-birth',
    stage: 'Personal details',
    Content: DateOfBirthScreen,
    isAnswered: allPresent('dobDay', 'dobMonth', 'dobYear'),
  },
  {
    id: 'phone',
    stage: 'Personal details',
    Content: PhoneScreen,
    isAnswered: allPresent('phoneNumber'),
  },
  {
    id: 'home-address',
    stage: 'Personal details',
    Content: HomeAddressScreen,
    isAnswered: allPresent(
      'homeStreet',
      'homeHouseNumber',
      'homePostcode',
      'homeTown',
    ),
  },
  {
    id: 'consent',
    stage: 'Personal details',
    Content: PrivacyConsentScreen,
    isAnswered: (form) => form.privacyPolicyAgreement === true,
  },
];
